import lazyScreen from '../utils/lazyScreen';
const MEDExplorer = lazyScreen(() => import('../pages/media/MEDExplorer/index.js'), 'pages/media/MEDExplorer/index.js');

export default [
    { path: '/media/MEDExplorer', component: MEDExplorer }
];
